import React, { Fragment, useEffect, useState } from "react";
import { useContextSelector } from "use-context-selector";
import { inRange, isEmpty, isNumber } from "lodash";
import BetSlipContext from "../../../context/BetSlipContext";
import { formatWithCommas } from "../../../Utils/Toast";
import RenderBookmakerOdds from "./RenderBookmakerOdds";
import { useBookmakerLogic } from "../../useLogic/useBookmakerLogic";

const BookmakerVelkie = ({
  runner,
  backOdds,
  layOdds,
  oldBack,
  oldLay,
  profileData,
  marketName,
  detail,
  ms,
  typeGame,
  user,
  marketId,
  totalMatched,
  addToFavioute,
  position,
}) => {
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });

  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });

  const [active, setActive] = useState(true);
  const { localLimit, handelChange, checkArrays, fav } = useBookmakerLogic({
    backOdds,
    layOdds,
    oldBack,
    oldLay,
    profileData,
    marketName,
    detail,
    ms,
    typeGame,
    user,
    marketId,
    totalMatched,
    position,
  });
  return (
    <section>
      <div className="mt-2">
        <div
          onClick={() => {
            setActive(!active);
          }}
          className="relative py-1.5 pr-9 pl-1.5 text-sm h-34px text-primary bg-primary rounded-xl cursor-pointer transition-all duration-300 rounded-t-xl rounded-b-none"
        >
          <div className="flex justify-start items-center text-base text-market-name font-normal">
            <div
              onClick={(e) => {
                if (!isEmpty(detail?.bookmakerMarketId)) {
                  e.preventDefault();
                  e.stopPropagation();
                  addToFavioute(
                    detail?.eventId,
                    "Bookmaker",
                    detail?.bookmakerMarketId,
                    detail?.eventType
                  );
                }
              }}
              className="-ml-2 sm:-ml-1 pt-px mb-3px"
            >
              <div
                data-v-117db823
                className="w-8 h-6 flex justify-center items-center"
                style={{
                  "--b64d5fc0": "0.4363636363636363",
                  "--3cad14f0": "-0.9375rem",
                }}
              >
                <div
                  data-v-117db823
                  className={`fave ${
                    fav ? "animate" : ""
                  } bg-star-sprit-black-webp`}
                />
              </div>
            </div>
            <p className="pr-2 h-6">Bookmaker</p>
          </div>
          <span
            className={`icon-arrow-down-sencodary absolute right-4 top-3 text-12 text-market-name transition-transform origin-center duration-300 transform ${
              active ? "rotate-180" : ""
            } `}
          />
        </div>
        {active && (
          <div>
            <div className="rounded-b-lg">
              <div className="pt-1 px-1 bg-white rounded-bl-lg rounded-br-lg">
                <div className="mb-1 flex justify-between items-center">
                  <div className="w-9/12" />
                  <div className="w-4/12 grid gap-0.5 grid-cols-2">
                    <div className="min-w-min text-10 text-global-font-on-light text-center">
                      Back
                    </div>
                    <div className="min-w-min text-10 text-global-font-on-light text-center">
                      Lay
                    </div>
                  </div>
                </div>
                <div data-v-d884c596>
                  <div data-v-d884c596 className="relative space-y-px">
                    {runner?.map((item, index) => {
                      const odds_back = backOdds?.filter(
                        (todd) =>
                          todd?.runnerName?.toLowerCase() ==
                          (item?.RunnerName?.toLowerCase() ||
                            item?.runnerName?.toLowerCase())
                      );
                      const odds_lay = layOdds?.filter(
                        (todd) =>
                          todd?.runnerName?.toLowerCase() ==
                          (item?.RunnerName?.toLowerCase() ||
                            item?.runnerName?.toLowerCase())
                      );
                      const old_back = oldBack?.filter(
                        (todd) =>
                          todd?.runnerName?.toLowerCase() ==
                          (item?.RunnerName?.toLowerCase() ||
                            item?.runnerName?.toLowerCase())
                      );
                      const old_lay = oldLay?.filter(
                        (todd) =>
                          todd?.runnerName?.toLowerCase() ==
                          (item?.RunnerName?.toLowerCase() ||
                            item?.runnerName?.toLowerCase())
                      );
                      let disabelBack =
                        "lockBackBets" in item ? item?.lockBackBets : false;
                      let disabelLay =
                        "lockLayBets" in item ? item?.lockLayBets : false;
                      let disableFull = checkArrays(
                        odds_back?.slice(0, 1),
                        odds_lay?.slice(0, 1),
                        localLimit
                      );
                      let showPosition =
                        (isNumber(item?.position) &&
                          position?.length > 0 &&
                          Math.abs(item?.position) > 0) ||
                        (Math.abs(item?.newPosition) >= 0 &&
                          showBetDialog &&
                          betSlipObject?.playType == typeGame &&
                          detail?.marketId ==
                            betSlipObject?.object?.newMarketId);

                      return (
                        <div
                          data-v-d884c596
                          className="bookmaker_selection_line"
                        >
                          <div
                            data-v-d884c596
                            className="relative flex justify-start items-center bg-black-100"
                          >
                            <h2
                              data-v-d884c596
                              className="px-2 w-9/12 h-full leading-5 text-13 flex flex-col justify-center break-all"
                            >
                              {item?.RunnerName || item?.runnerName}

                              {showPosition && (
                                <div
                                  className="text-10 leading-normal flex"
                                  data-testid="forecast"
                                >
                                  {" "}
                                  {isNumber(item?.position) &&
                                    position?.length > 0 &&
                                    Math.abs(item?.position) > 0 && (
                                      <span
                                        className={`flex items-center ${
                                          item?.position > 0
                                            ? "text-success"
                                            : "text-error"
                                        } `}
                                      >
                                        {isNumber(item?.position) &&
                                        Math.abs(item?.position) > 0
                                          ? item?.position > 0
                                            ? Math?.abs(item?.position).toFixed(
                                                2
                                              )
                                            : `(${Math.abs(
                                                item?.position
                                              ).toFixed(2)})`
                                          : ""}
                                      </span>
                                    )}
                                  {Math.abs(item?.newPosition) >= 0 &&
                                    showBetDialog &&
                                    betSlipObject?.playType == typeGame &&
                                    marketId ==
                                      betSlipObject?.object?.newMarketId && (
                                      <span
                                        className={`flex items-center ${
                                          item?.newPosition > 0
                                            ? "text-success"
                                            : "text-error"
                                        } `}
                                      >
                                        <div className="icon-arrow-left rotate-180 flex text-6 mx-0.5" />{" "}
                                        {item?.newPosition > 0
                                          ? Math.abs(item?.newPosition).toFixed(
                                              2
                                            )
                                          : `(${Math.abs(
                                              item?.newPosition
                                            ).toFixed(2)})`}
                                      </span>
                                    )}
                                </div>
                              )}
                            </h2>

                            <RenderBookmakerOdds
                              component={typeGame}
                              index={index}
                              marketName={marketName}
                              item={item}
                              disabelBack={disabelBack}
                              oldBack={old_back}
                              oldLay={old_lay}
                              disableFull={disableFull}
                              disabelLay={
                                detail?.market == "Win" ? true : disabelLay
                              }
                              isInPlay={
                                ["Win", "Winner"].includes(detail?.market)
                                  ? true
                                  : detail?.status == "in_play"
                                  ? true
                                  : false
                              }
                              handelChange={handelChange}
                              odds_lay={odds_lay}
                              odds_back={odds_back}
                              limit={localLimit}
                              ms={ms}
                              betType={betSlipObject?.betType}
                              active={
                                showBetDialog &&
                                marketId == betSlipObject?.newMarketId &&
                                item?.SelectionId ==
                                  betSlipObject?.object?.SelectionId &&
                                "bookmaker" == betSlipObject?.playType
                              }
                            />
                          </div>
                        </div>
                      );
                    })}
                    {ms != 1 && (
                      <div data-v-d884c596>
                        <div
                          data-v-d884c596
                          className="absolute right-0 top-0 flex justify-center items-center h-full bg-black-700 opacity-80 text-11 text-white rounded-md w-31%"
                        >
                          Suspend
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    data-v-d884c596
                    className="py-1 flex justify-center items-center"
                  >
                    <div
                      data-v-d884c596
                      className="flex flex-1 justify-end items-center"
                    >
                      <div
                        data-v-d884c596
                        className="flex items-center text-black-600"
                        data-testid="betLimit"
                      >
                        <i className="px-1 mt-0.5 text-14 icon-min-max" />
                        <span className="px-0.5 text-11">min/max</span>
                        <span className="px-1 text-11 font-bold">
                          {" "}
                          {formatWithCommas(localLimit?.minAmount)}/
                          {formatWithCommas(localLimit?.maxAmount)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default BookmakerVelkie;
